import { render } from "./LabelsFooter.vue?vue&type=template&id=51281cd6&scoped=true"
import script from "./LabelsFooter.vue?vue&type=script&lang=js"
export * from "./LabelsFooter.vue?vue&type=script&lang=js"

import "./LabelsFooter.vue?vue&type=style&index=0&id=51281cd6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51281cd6"]])

export default __exports__